import {
    Tooltip as TooltipBase,
    TooltipStateful as TooltipStatefulBase,
} from '@yandex-lego/components/Tooltip/desktop/bundle';

import './LegoTooltip.scss';

export const Tooltip = TooltipBase;
export const TooltipStateful = TooltipStatefulBase;
